var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"error-page"},[(_vm.$route.query.reason === 'open-from-admin')?_c('div',[_c('p',[_vm._v("Open Airfields from the Apps section of your Shopify admin.")])]):_c('div',[_c('p',[_vm._v("Something went wrong.")]),_vm._v(" "),_c('p',[_vm._v("Please try again.")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2384d50a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/error.vue
// module id = 578
// module chunks = 0